export { CollapseDirective } from './collapse.directive';
export { CollapseModule } from './collapse.module';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
